var _circle, _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgSmallPending(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 12,
    cy: 12,
    r: 12,
    fill: "white"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.375 8.39353C9.2812 7.64154 10.6602 6.875 12.5 6.875C15.6241 6.875 18.125 9.395 18.125 12.5C18.125 15.6066 15.6066 18.125 12.5 18.125C9.3934 18.125 6.875 15.6066 6.875 12.5C6.875 12.0858 7.21079 11.75 7.625 11.75C8.03921 11.75 8.375 12.0858 8.375 12.5C8.375 14.7782 10.2218 16.625 12.5 16.625C14.7782 16.625 16.625 14.7782 16.625 12.5C16.625 10.2202 14.7925 8.375 12.5 8.375C11.0976 8.375 10.0429 8.95618 9.32389 9.55533C9.31269 9.56467 9.30157 9.574 9.29055 9.58333H9.79167C10.2059 9.58333 10.5417 9.91912 10.5417 10.3333C10.5417 10.7475 10.2059 11.0833 9.79167 11.0833H7.625C7.21079 11.0833 6.875 10.7475 6.875 10.3333V7.89583C6.875 7.48162 7.21079 7.14583 7.625 7.14583C8.03921 7.14583 8.375 7.48162 8.375 7.89583V8.39353Z",
    fill: "#CC7700"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSmallPending);
export default __webpack_public_path__ + "static/media/smallPending.bb1e4461c78ead2bf0f93d9665da1256.svg";
export { ForwardRef as ReactComponent };